import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import TeamMemberModal from './team_member_modal';

import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';

import { useDrag, useDrop } from 'react-dnd';
import { Badge } from 'react-bootstrap-5';

function TeamMember({ editTeamMember, deleteTeamMember, index, teamId, onReorder, onReorderSave, ...props }) {
  const [editTeamMemberModalOpen, setEditTeamMemberModalOpen] = React.useState(false);
  const [teamMember, setTeamMember] = React.useState(() => setTeamMemberToProps());
  const type = `Team${teamId}Members`;

  function setTeamMemberToProps() {
    return {
      cellPhoneNumber: props.teamMember.cellPhoneNumber,
      email: props.teamMember.email,
      name: props.teamMember.name,
      jobTitle: props.teamMember.jobTitle,
      officeName: props.teamMember.officeName,
      phoneNumber: props.teamMember.phoneNumber,
      licenseNumber: props.teamMember.licenseNumber,
      sortOrder: props.teamMember.sortOrder,
      id: props.teamMember.id
    };
  }

  const closeModal = () => {
    setEditTeamMemberModalOpen(false);
    setTeamMember(setTeamMemberToProps());
  };

  const beginEditTeamMember = () => {
    setEditTeamMemberModalOpen(false);
    editTeamMember(teamMember.id, teamMember);
  };

  const ref = useRef(null);
  const dragRef = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    collect: monitor => ({ isDragging: monitor.isDragging() }),
    item: { ...teamMember, index },
    type,
    end() {
      onReorderSave();
    }
  });

  const [, drop] = useDrop({
    accept: type,
    hover(item, monitor) {
      if (!monitor.canDrop()) return;

      if (teamMember.id !== item.id) {
        onReorder(item.index, index);
      }
    }
  });

  preview(drop(ref));
  drag(dragRef);

  const renderDragSource = () => {
    return (
      <span className="me-2" ref={dragRef} style={{ cursor: 'grab' }}>
        <FontAwesomeIcon icon={faGripDotsVertical}/>
      </span>
    );
  };

  return (
    <Badge bg="" className="badge-muted badge-secondary" ref={ref} style={{ opacity: isDragging ? 0 : 1 }}>
      <TeamMemberModal
        editOrCreateTeamMember={beginEditTeamMember}
        modalOpen={editTeamMemberModalOpen}
        newTeamMember={false}
        setTeamMember={setTeamMember}
        teamMember={teamMember}
        onModalClose={closeModal}
      />
      <div className="team-member p-1">
        {renderDragSource()}
        {teamMember.name}
        <FontAwesomeIcon
          className="clickable ms-2"
          icon={faPencilAlt}
          size="sm"
          onClick={() => setEditTeamMemberModalOpen(true)}
        />
        <FontAwesomeIcon
          className="clickable text-danger ms-2"
          icon={faTrashAlt}
          size="sm"
          onClick={() => deleteTeamMember(teamMember.id)}
        />
      </div>
    </Badge>
  );
}

TeamMember.propTypes = {
  deleteTeamMember: PropTypes.func.isRequired,
  editTeamMember: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  teamId: PropTypes.number.isRequired,
  teamMember: PropTypes.shape({
    cellPhoneNumber: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    jobTitle: PropTypes.string.isRequired,
    licenseNumber: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    officeName: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    sortOrder: PropTypes.number
  }).isRequired,
  onReorder: PropTypes.func.isRequired,
  onReorderSave: PropTypes.func.isRequired
};

export default TeamMember;
